/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_Col_LeftInputs */

const vi_lot_debt_fill_col_left = /** @type {(inputs: Lot_Debt_Fill_Col_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn nợ`)
};

/**

* @param {Lot_Debt_Fill_Col_LeftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_col_left = /** @type {((inputs?: Lot_Debt_Fill_Col_LeftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Col_LeftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_col_left(inputs)
});